module.exports = __webpack_public_path__ + "img/file22.b236db97.png";